import { orderBy as _orderBy } from 'lodash';
export const filteredReportingUnitsByBrand =
  (brand: string, filter: string) => state => {
    let units = state.ReportingUnitsReducer?.reportingUnitsByBrand?.[brand];
    if (units) {
      filter = (filter || '').toLowerCase();
      units =
        filter.length >= 3
          ? units.filter(unit => unit.name.toLowerCase().includes(filter))
          : [];
    }
    return units;
  };

export const getReportingUnitsByBrand =
  (brand: string, includeCompanyRU = false) =>
  state => {
    const obj = state.ReportingUnitsReducer?.reportingUnitsByBrand?.[brand];
    const reportingUnits = obj
      ? _orderBy(
          Object.entries<any>(obj).map(([id, item]) => ({
            ...item,
            test: 'test',
            id,
          })),
          ['name'],
          ['asc'],
        )
      : undefined;
    if (includeCompanyRU === false && reportingUnits?.length) {
      return (reportingUnits as Array<{ isCompanyRU?: number }>).filter(
        reportingUnit => reportingUnit?.isCompanyRU !== 1,
      );
    }
    return reportingUnits;
  };

export const getReportingUnitById =
  (brand: string, reportUnitId: any) => state => {
    let item;
    const reportingUnitState = state.ReportingUnitsReducer || {};
    const reportUnit =
      reportingUnitState.reportingUnitsByBrand?.[brand]?.[reportUnitId];
    if (brand && reportUnitId) {
      item = {
        id: reportUnitId,
        ...reportUnit,
        groups: reportUnit.groups
          ?.map(
            groupId =>
              reportingUnitState.franchiseGroupsById?.[brand]?.[groupId],
          )
          .filter(group => !!group),
      };
    }
    return item;
  };

export const getFranchiseGroups = (brand: string) => state => {
  const reportingUnitState = state.ReportingUnitsReducer || {};
  return reportingUnitState.franchiseGroupsById?.[brand] || {};
};
